/**
 * Guard for CYP ADHD Clinical Interview paragraph generation.
 *
 * The MSE and Risk Assessment steps are clinician-entered on the CI page and
 * are NOT seeded at patient creation: the stage document has no `mse` /
 * `riskAssessment` field until the clinician records something there. The
 * Cloud Function fail-closes on a missing field (get_llm_inputs_cyp_ci raises,
 * surfacing as an INTERNAL 500), so generation must never be requested for
 * these two sections while their field is absent or empty. Every other CI
 * section lives under data.sections from patient creation, so it always
 * resolves server-side.
 *
 * @param {Object} ciStage      The clinicalInterview stage document.
 * @param {string} sectionTitle Report section title (backend SECTION_PARAGRAPHS key).
 * @returns {boolean} Whether the backend can extract inputs for this section.
 */
export function hasCypCiPageSectionData(ciStage, sectionTitle) {
  if (sectionTitle === 'Mental State Examination') {
    return isNonEmptyObject(ciStage?.mse);
  }
  if (sectionTitle === 'Risk Assessment') {
    return isNonEmptyObject(ciStage?.riskAssessment);
  }
  return true;
}

function isNonEmptyObject(value) {
  return Boolean(value)
    && typeof value === 'object'
    && !Array.isArray(value)
    && Object.keys(value).length > 0;
}
